import React, { useEffect, useState } from 'react';
import '../../../../../../../../styles.css';
import { FaPowerOff } from "react-icons/fa6";
import { getThemeMode, getUserId, local } from '../../../../../../../../utils/helper';
import WebSocketManager from '../../../../../../../../manager/WebSocketManager';
import { resetMessages } from '../../../../../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { IoMdClose } from 'react-icons/io';
import { MdOutlineKeyboardArrowLeft, MdOutlineFullscreen, MdOutlineFullscreenExit } from "react-icons/md";
import ChatFullScreenButton from '../../../../../../../chatFullScreenButton';

const webSocketManager = new WebSocketManager();

const Header = ({ showStartScreen, title, subtitle, toggleChat, showCloseButton, titleAvatar, messages, onSendMessage }) => {
  const dispatch = useDispatch();
  const { widgetConfig, isChatFullScreen } = useSelector((state) => ({
    widgetConfig: state.messages.widgetConfig,
    isChatFullScreen: state.messages.isChatFullScreen,
  }));
  const [isBgLight, setIsBgLight] = useState(false);
  const [showEndChatModal, setShowEndChatModal] = useState(false);

  useEffect(() => {
    setIsBgLight(getThemeMode(widgetConfig?.widgetConfig?.lookAndFeel?.backgroundColor))
  }, [])

  const handleChatExit = () => {
    // dispatch(resetMessages([]))
    const event = new CustomEvent("resetChat", {
      detail: "Button was clicked!",
    });
    window.dispatchEvent(event);
    setShowEndChatModal(false);
  }

  const toggleEndChatModal = () => {
    // dispatch(resetMessages([]))
    setShowEndChatModal(!showEndChatModal);
  };

  const handleBack = () => {
    const event = new CustomEvent("resetActiveWidget", {
      detail: "Button was clicked!",
    });
    window.dispatchEvent(event);
  }

  return (
    <div className={`${messages?.length <= 1 ? "rcw-first-msg-header" : ""} rcw-header`}>
      {messages?.length <= 1 && <span className="top-right"></span>}
      {showCloseButton && !showStartScreen && (
        <button className="rcw-close-button" onClick={toggleEndChatModal}>
          <FaPowerOff size={18} color={isBgLight ? '#000000' : '#ffffff'} />
        </button>
      )}
      {messages?.length <= 1 && <div className='rcw-receiver-logo'><img src='./images/receiver-header.svg' /></div>}
      {/* <div className='header-back'><IoIosArrowBack size={18}/></div> */}
      <div className='rcw-left-arrow' onClick={handleBack}>  <MdOutlineKeyboardArrowLeft cursor={'pointer'} size={30} color={isBgLight ? '#000000' : '#ffffff'} /></div>
      <h4 className="rcw-title" style={{ maxWidth: isChatFullScreen ? "800px" : ""}}>
        {titleAvatar && <img src={titleAvatar} className="avatar" alt="profile" />}
        {title}
      </h4>
      <ChatFullScreenButton isBgLight={isBgLight} />
      {messages?.length <= 1 && <span className='rcw-subtitle'>{subtitle}</span>}
      {messages?.length > 1 && <div className='rcs-header-right'></div>}
      {showEndChatModal && (
        <div className="end-chat-modal">
          <div className="end-chat-modal-content">
            <div className='end-chat-modal-close'>
              <IoMdClose size={18} color='#000000' onClick={toggleEndChatModal} />
            </div>
            <img src='/images/end-chat.png' />
            <h5>End Chat</h5>
            <p>Are you sure you want to end this chat?</p>
            <button className="btn-confirm" onClick={handleChatExit}>End Chat</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
